import React, { useEffect } from 'react';

import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import TunnelResultPage from '@/components/TunnelResultPage/TunnelResultPage';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

type CancelPageState = {
  title: string;
  subtitle: string;
  ctaLabel: string;
  iconName: TotemIconId;
  iconVariant: 'success' | 'error';
};

export const FaireVersementCancel: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const location = useLocation();
  const navState = (location.state as CancelPageState) ?? null;
  useEffect(() => {
    if (user?.id && user.type && user.success) {
      TRACKING_INSTANCE.setTcVars({
        page_nom: 'abandon versement',
        page_template: 'espace client',
        user_id: user.id,
        user_client: user.type === 'Client',
        user_connexion: user.success,
        user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
        tunnel_produit: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratNomProduit,
        tunnel_metier: 'espace client placement',
        tunnel_sous_metier: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratFamille,
        tunnel_categorie_produit: 'parcours de versement',
      });
      void TRACKING_INSTANCE.triggerEvent('page', undefined, {
        event_id: 'page',
        event_categorie: 'affichage espace client',
        event_nom: 'abandon versement',
        event_page: 'abandon versement',
      });
    }
  }, [user?.id, user?.type, user?.success]);

  return (
    <TunnelResultPage
      iconName={navState?.iconName ?? 'check-circle-solid'}
      iconVariant={navState?.iconVariant ?? 'success'}
      title={navState?.title ?? t('faireVersementCancel.title')}
      subtitles={navState?.subtitle ? [navState.subtitle] : [t('faireVersementCancel.subtitle')]}
      ctaLabel={navState?.ctaLabel ?? t('faireVersementCancel.cta')}
      onCtaClick={() => {
        queryClient.invalidateQueries();
        navigate(ROUTE.DASHBOARD);
      }}
    />
  );
};
